import { FC, useState, useRef, useEffect } from 'react';
import { Popover, BodyText } from '@servicetitan/design-system';

interface ValuePopoverProps {
    value: string[];
    title: string;
    trigger: string;
}

export const ValuePopover: FC<ValuePopoverProps> = ({ value, title, trigger }) => {
    const [open, setOpen] = useState(false);
    const node = useRef<HTMLSpanElement>(null);

    const handleOpen = () => setOpen(!open);

    const handleClickOutside = (e: MouseEvent) => {
        if (!node.current?.contains(e.target as Node)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <span ref={node}>
            <Popover
                el="span"
                open={open}
                direction="b"
                width="xs"
                trigger={
                    <BodyText
                        bold
                        inline
                        size="small"
                        onClick={handleOpen}
                        className="c-blue-400 cursor-pointer"
                    >
                        {trigger}
                    </BodyText>
                }
            >
                <BodyText bold className="m-b-1">
                    {title}
                </BodyText>
                <ul className="p-l-2 m-y-0">
                    {value.map(item => (
                        <li className="fs-1" key={item}>
                            {item}
                        </li>
                    ))}
                </ul>
            </Popover>
        </span>
    );
};
